<template>
  <div class="callout-block">
    <v-form ref="form" @submit.prevent="onSubmit">
      <div class="copy">
        <div class="typography">
          <slot />
        </div>
        <div class="standard-form-style">
          <div class="fields">
            <TextfieldComponent :label="$t('program-name')" v-model="submission.name" :rules="[textFieldRequired]" />
          </div>
        </div>
      </div>
      <div class="actions">
        <button class="rect" v-ripple>{{ $t('continue') }}</button>
      </div>
    </v-form>
  </div>
</template>

<script lang="ts" setup>
import * as yup from 'yup';
import { inject, onMounted, reactive, ref } from 'vue';
import Manager from '../core/Manager';
import { getLocale } from '../core/Utils';
import Submission from '../modules/quality-mentoring-form/models/submission/Submission';
import Settings from '../core/Settings';
import TextfieldComponent from '../frontendkit/vuetify-components/VuetifyTextfieldComponent.vue';
import SelectComponent from '../frontendkit/vuetify-components/VuetifySelectComponent.vue';

const t: any = inject('t');

const form = ref('');

const purposeOptions: any[] = [''];
purposeOptions.push({title: t("creating-a-new-mentoring-program"), value: "creating-a-new-mentoring-program"});
purposeOptions.push({title: t("assessing-an-existing-mentoring-program"), value: "assessing-an-existing-mentoring-program"});
purposeOptions.push({title: t("testing-the-assessment-tool"), value: "testing-the-assessment-tool"});
purposeOptions.push({title: t("other"), value: "other"});

Manager.getInstance().submission = new Submission();
const submission = reactive(Manager.getInstance().submission);
const user = Manager.getInstance().user;
submission.organizationName = user.organization;
submission.role = user.role;
const checkbox = ref(false);

const required = (v, errorMessage) => {
  return yup.string().required().isValidSync(v) || errorMessage;
}

const textFieldRequired = (v) => {
  return required(v, t('required-textfield-error'));
}

const selectRequired = (v) => {
  return required(v, t('required-select-error'));
}

const privacyPolicyRequired = (v) => {
  return v === true || t('required-privacy-policy-error');
}

const onSubmit = async (submitEventPromise) => {
  const result = await submitEventPromise;
  if(!result.valid) {
    document.getElementById(form.value.errors[0].id).scrollIntoView({
      behavior: 'smooth'
    });
    return;
  }

  await submission.save();
  await Manager.getInstance().submissions.add(submission);
  window.location.href = `/${getLocale()}/overview?id=${submission.id}`
}
</script>

<style lang="scss">
[data-page=add-program],
[data-page=get-started]
{
  .callout-block {
    button {
      width: 100%;
    }
  }
  .fields {
    display: grid;
    grid-gap: 20px;
  }
  .privacy-policy {
    label {
      padding-left: 8px;
    }
  }
}
</style>
